import PropTypes from 'prop-types';
import { classNames } from '../utils';
import './Toggle.scss';

export const Toggle = ({ isEnabled, onChange, disabled = false, label, className }) => {
  const toggleClasses = classNames({
    'toggle-switch': true,
    'toggle-switch--enabled': isEnabled,
    'toggle-switch--disabled': disabled,
    [className]: className
  });

  const handleToggle = () => {
    if (!disabled) {
      onChange(!isEnabled);
    }
  };

  const handleKeyDown = (event) => {
    if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onChange(!isEnabled);
    }
  };

  return (
    <div className={toggleClasses} onClick={handleToggle} role={'button'} tabIndex={0} onKeyDown={handleKeyDown}>
      {label && <span className={'toggle-switch__label'}>{label}</span>}
      <div className={'toggle-switch__track'}>
        <div className={'toggle-switch__thumb'} />
      </div>
    </div>
  );
};

Toggle.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string
};
